import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useState, useEffect } from 'react';
import { editTaskInFirebase } from '../../redux/actions/TodoManipulation/editTaskInFirebaseAction';
import { useDispatch, useSelector } from 'react-redux';
import { findByIdInTreeList } from '../../utils/tree';

const TaskList = (props) => {
    let task = props.todo;
    const addItemMode = props.addItemMode;
    const showCompleted = props.showCompleted;
    const handleDragEnd = props.handleDragEnd;
    const [filteredTasks, setFilteredTasks] = useState([]);
    const dispatch = useDispatch();
    const projects = useSelector((state) => state.taskList.data);

    useEffect(() => {
        if (addItemMode) {
            setFilteredTasks(task.subTasksToAdd);
        }
        else if (task.children) {
            setFilteredTasks(
                task.children
                    .filter((child) => !showCompleted ? !child.isCompleted : true)
                    .sort((a, b) => {
                        const aSiblingOrder = a.siblingOrder || 0;
                        const bSiblingOrder = b.siblingOrder || 0;
                        if (aSiblingOrder === bSiblingOrder) {
                            return (a.globalPriority || 0) - (b.globalPriority || 0);
                        }
                        return aSiblingOrder - bSiblingOrder;
                    })
            );
        }
        

    }, [props.todo, showCompleted]);

    

    const toggleShowModal = (projectId, event) => {
        const allowedClassNames = [
            "gw-icon-button",
            "gt-task__completed",
            "gw-icon-button__icon",
        ];
        if (task.children) {
            if (!allowedClassNames.some(className => event.target.classList.contains(className))) {
                const todoItem = findByIdInTreeList(projects, projectId);
                dispatch({ type: "TOGGLE_EDIT_MODAL", payload: { todo: todoItem } });
            }
        }
        
    };

    return (
        <DragDropContext onDragEnd={handleDragEnd}>
            {filteredTasks?.length > 0 && (
                <Droppable droppableId={`droppable-${task.id}`}>
                    {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {
                                filteredTasks
                                    .map((child, childIndex) => (
                                        renderTask(child, childIndex, { toggleShowModal, addItemMode })
                                    ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            )}
        </DragDropContext>
    );
}

const renderTask = (task, index, additionalProps) => {
    /*const [isHovered, setIsHovered] = useState(false);*/
    const dispatch = useDispatch();
    const { title, id, color, $id, isCompleted } = task;
    const toggleShowModal = additionalProps.toggleShowModal;
    const addItemMode = additionalProps.addItemMode;


    const handleMouseOver = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };
    function isNullOrUndefined(value) {
        return value === undefined || value === null;
    }

    const updateIsCompleted = () => {
        console.log("IsCompleted", isCompleted);

        const json = {
            id: id,
            Title: title,
            IsCompleted: !isCompleted,
            HasDescription: (isNullOrUndefined(task.hasDescription)) ? false.toString() : task.hasDescription,
            Description: task.description,
            HasDueDate: (isNullOrUndefined(task.hasDueDate)) ? false.toString() : task.hasDueDate,
            DueDate: task.dueDate,
            VisualSize: task.visualSize.toString(),
            HasSnoozedUntil: (isNullOrUndefined(task.hasSnoozedUntil)) ? false.toString() : task.hasSnoozedUntil,
            SnoozedUntil: task.snoozedUntil
        }

        dispatch(editTaskInFirebase(json));
    };

    const countCompletedTasks = (parent) => {
        let totalTasks = 0;
        let completedTasks = 0;

        if (parent.children && parent.children.length > 0) {
            for (var child of parent.children) {
                totalTasks++;
                if (child.isCompleted) {
                    completedTasks++;
                }
            }
        }
        const returnValue = `${completedTasks}/${totalTasks}`;
        return returnValue;
    }

    return (
        <Draggable key={task.id} draggableId={task.id} index={index}>
            {(provided, snapshot) => {

                if (snapshot.isDragging) {
                    provided.draggableProps.style.left = undefined;
                    provided.draggableProps.style.top = undefined;
                }
                return (
                    <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    >
                        <div
                            className="gt-task"
                            onClick={(event) => {
                                    toggleShowModal(task.id, event);
                                } }
                        >
                            <div className="gt-task__color" style={{ background: task.color ? task.color.hexString : "#80C3E9" }}></div>
                            
                            {!addItemMode && (<>
                                <input className="gt-task__completed" type="checkbox" aria-label="Task completed?" onChange={updateIsCompleted}
                                    checked={isCompleted}
                                />
                                {task.children.length > 0 && (
                                    <svg
                                        className="gt-task__group-icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <use xlinkHref="#globaltasks-svg-folder"></use>
                                    </svg>
                                )}
                                </>
                            )}
                                
                                
                            
                            

                            <p className="gt-task__title">{task.title}</p>
                            {!addItemMode && (<>
                                {task.children.length > 0 && (


                                    <div style={{ marginRight: "10px" }}>
                                        <svg className="gt-task__group-icon" xmlns="http://www.w3.org/2000/svg">
                                            <use href="#globaltasks-svg-checklist" />
                                        </svg>
                                        {countCompletedTasks(task)}
                                    </div>

                                )
                            }</>) }
                                
                                    
                                

                            
                           
                        </div>

                        <Droppable droppableId={`droppable-${task.id}`}>
                            {(provided) => (
                                <div ref={provided.innerRef} {...provided.droppableProps}>

                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </div>
                )
            }}
        </Draggable>
    );
};


export default TaskList;